import { Customer, PlasticMaterialMixingTaskStatus, PlasticsMaterial, PlasticsOrderedProduct, ProductVersion } from "@prism/prism-shared";

export interface PlasticsMaterialMixingTask {
  id: string;
  materialId: string;
  completedQuantity: number;
  releasedGroupId: string;
  totalQuantity: number;
  suggestedQuantity: number;
  orderedProductId: string;
  // parent product
  associatedProductId: string;
  associatedProductQuantity: number;
  updatedById: string;
  updatedOn: Date;
  status: PlasticMaterialMixingTaskStatus;
  completedById: string | null;
  completedOn: Date | null;
}



export interface DisplayPlasticsMaterialMixingTask {
  task: PlasticsMaterialMixingTask;
  material: PlasticsMaterial;
  orderedProduct: PlasticsOrderedProduct | null;
  orderedProductVersion: ProductVersion | null;
  parentProductVersion: ProductVersion | null;
  customer: Customer | null;
}

export interface DisplayWaitingPlasticsMaterialMixingTaskGroup {
  displayMixingTasks: DisplayPlasticsMaterialMixingTask[];
  material: PlasticsMaterial;
  totalQuantity: number;
  dueDate: Date | null;
}

export interface DisplayReleasedPlasticsMaterialMixingTaskGroup {
  displayMixingTasks: DisplayPlasticsMaterialMixingTask[];
  material: PlasticsMaterial;
  totalCompletedQuantity: number;
  totalQuantity: number;
  totalCompletedQuantityPercentage: number;
  dueDate: Date | null;
  releasedGroupId: string;
}


export const toDisplayMixingTasks = (
  tasks: PlasticsMaterialMixingTask[],
  materialDict: Record<string, PlasticsMaterial>,
  productIdToReleasedProductVersionDict: Record<string, ProductVersion>,
  customerDict: Record<string, Customer>,
  orderedProducts: PlasticsOrderedProduct[],
): DisplayPlasticsMaterialMixingTask[] => {

  return tasks.map((task) => {
    if (!task.orderedProductId) {
      return {
        task,
        orderedProductVersion: null,
        parentProductVersion: null,
        orderedProduct: null,
        material: materialDict[task.materialId],
        customer: null,
      }
    }
    const orderedProduct = orderedProducts.find(op => op.id === task.orderedProductId) as PlasticsOrderedProduct;
    const displayMixingTask: DisplayPlasticsMaterialMixingTask = {
      task,
      orderedProductVersion: productIdToReleasedProductVersionDict[orderedProduct.productId],
      parentProductVersion: productIdToReleasedProductVersionDict[task.associatedProductId],
      orderedProduct,
      material: materialDict[task.materialId],
      customer: customerDict[orderedProduct.customerId],
    }
    return displayMixingTask;
  })
    .sort((a, b) => {
      const aCompleted = a.task.status === PlasticMaterialMixingTaskStatus.Completed;
      const bCompleted = b.task.status === PlasticMaterialMixingTaskStatus.Completed;
      if (aCompleted && !bCompleted) {
        return 1;
      }
      if (!aCompleted && bCompleted) {
        return -1;
      }
      return 0;
    })



}